<script lang="ts">
  import {
    PUBLIC_KLARNA_MESSAGING_SECRET_STORE_US,
    PUBLIC_KLARNA_MESSAGING_SECRET_STORE_UK,
    PUBLIC_KLARNA_MESSAGING_SECRET_STORE_EU
  } from '$env/static/public';
  import { region } from '$lib/region';

  const KLARNA_KEY = {
    us: PUBLIC_KLARNA_MESSAGING_SECRET_STORE_US,
    uk: PUBLIC_KLARNA_MESSAGING_SECRET_STORE_UK,
    eu: PUBLIC_KLARNA_MESSAGING_SECRET_STORE_EU
  }[$region];
</script>

<svelte:head>
  <script
    data-environment="production"
    src="https://js.klarna.com/web-sdk/v1/klarna.js"
    data-client-id={KLARNA_KEY}
    defer
  ></script>
</svelte:head>
